import { render, staticRenderFns } from "./ContentBoxItem.vue?vue&type=template&id=7538d97c&"
import script from "./ContentBoxItem.vue?vue&type=script&lang=js&"
export * from "./ContentBoxItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports